import { render, staticRenderFns } from "./RenyuanList.vue?vue&type=template&id=39446d20&scoped=true"
import script from "./RenyuanList.vue?vue&type=script&lang=js"
export * from "./RenyuanList.vue?vue&type=script&lang=js"
import style0 from "./RenyuanList.vue?vue&type=style&index=0&id=39446d20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39446d20",
  null
  
)

export default component.exports